import Service from "./service"

class LoyaltyService extends Service {
    async getLoyalty(acvId) {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        };

        return await this.authenticatedFetch(
            `${process.env.REACT_APP_PORTAL_API_URI}/Loyalty?query.acvId=${acvId}`,
            requestOptions
        );
    }

    async getLevelGrades() {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        };

        return await this.authenticatedFetch(
            `${process.env.REACT_APP_PORTAL_API_URI}/Loyalty/level-grades`,
            requestOptions
        );
    }

    async getLevelBonuses() {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        };

        return await this.authenticatedFetch(
            `${process.env.REACT_APP_PORTAL_API_URI}/Loyalty/level-bonuses`,
            requestOptions
        );
    }
}

export default new LoyaltyService();
